// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdLinkAliasesGetTriggerableLinksResult = arrayOf(
  objectOf({
    link_data: objectOf({
      link_id: string,
      campaign_id: string,
      display_value: string,
    }),
  })
);
